import { Suspense } from "react";
import { Outlet } from "react-router-dom";
import { ContentSpinner } from "@/components/contentSpinner.component";
import { FloatingChatButton } from "@/components/floatingChatButton.component";
import { MobileBottomNav } from "@/components/mobileBottomNav.component";
import { MobileTopBar } from "@/components/mobileTopBar.component";
import { ResponsiveMediaPlayer } from "@/components/player/responsiveMediaPlayer.component";
import { PostListenPrompt } from "@/components/postListenPrompt.component";
import { Sidebar } from "@/components/sidebar.component";
import { ActivationUpgradePrompt } from "@/features/onboarding/ActivationUpgradePrompt.component";
import { TrialCapModal } from "@/features/trial/TrialCapModal.component";
import { TrialCountdownBanner } from "@/features/trial/TrialCountdownBanner.component";
import { useLayout } from "@/lib/contexts/layout.context";

/**
 * Layout for authenticated/main application pages
 * Includes sidebar and media player
 */
export function MainLayout() {
	const { showMediaPlayer } = useLayout();

	return (
		<div className="flex h-screen overflow-hidden bg-background text-foreground">
			<Sidebar />
			<main
				className={`flex-1 min-h-0 overflow-y-auto transition-all duration-300 pt-18 md:pt-0 ${
					showMediaPlayer
						? "pb-16 md:pb-32" // Extra padding when media player is visible
						: "pb-8 md:pb-6" // Normal padding for bottom nav on mobile
				}`}
			>
				<TrialCountdownBanner />
				<Suspense fallback={<ContentSpinner />}>
					<Outlet />
				</Suspense>
			</main>
			{showMediaPlayer && <ResponsiveMediaPlayer offsetForSidebar={true} />}
			<MobileTopBar />
			<MobileBottomNav />
			<FloatingChatButton />
			<TrialCapModal />
			<PostListenPrompt />
			<ActivationUpgradePrompt />
		</div>
	);
}
